<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>import CSV</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
      <div class="col-3">
        <button type="button" class="btn-sm btn-outline-primary" v-on:click="download">フォーマットを出力する</button> 
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-4">
        <label>操作を選択してください</label>

        <select class="form-control" v-model="current" v-if="isSuper && this.$store.getters.hospital.useFederation">
          <option value="2">{{ this.deleteUserText }}</option>
          <option value="4" v-show="this.$store.getters.hospital.isConference">{{ this.updateUserConferenceInfoText }}</option>
        </select>

        <select class="form-control" v-model="current" v-if="isSuper && !this.$store.getters.hospital.useFederation">
          <option value="1">{{ this.createUserText }}</option>
          <option value="3">{{ this.updateUserText }}</option>
          <option value="4" v-show="this.$store.getters.hospital.isConference">{{ this.updateUserConferenceInfoText }}</option>
        </select>

        <select class="form-control" v-model="current" v-if="!isSuper && this.$store.getters.hospital.useFederation" disabled>
          <option value="2">{{ this.deleteUserText }}</option>
        </select>

        <select class="form-control" v-model="current" v-if="!isSuper && !this.$store.getters.hospital.useFederation">
          <option value="1">{{ this.createUserText }}</option>
          <option value="3">{{ this.updateUserText }}</option>
        </select>

      </div>
    </div>
    <div class="row py-2">
      <div class="col-1">
      </div>
      <div class="col-11">
        <form enctype="multipart/form-data" @submit.prevent="upload">
            <input type="file" ref="file" name="csvfile" v-on:change="selectedFile"/>
            <button class="btn btn-info">Upload</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import FileSaver from 'file-saver'
import { path } from '../../mixin/path'
import { sessions } from '../../mixin/session'
import { headers } from '../../mixin/headers'
import authority from '../../authority';

export default {
  name: 'Import',
  mixins: [path,sessions,headers],
  props: ['realms'],
  data: function(){
    return {
      current: this.$store.getters.hospital.useFederation? '2' : '1',
      message: '',
      uploadFile: null,
      createUserText: "ユーザーを作成",
      updateUserText: "ユーザーを更新",
      deleteUserText: "ユーザーを削除",
      updateUserConferenceInfoText: "ユーザーのビデオ通話カンファレンス利用情報を更新"
    }
  },
  mounted() {
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) this.current = this.$store.getters.hospital.useFederation? '2' : '1';
      }
    );
  },
  computed: {
    isSuper: function () {
      return Number(this.$store.state.user.privilege) === authority.isSuper;
    },
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    selectedFile(event){
      let files = event.target.files
      this.uploadFile = files[0]
    },
    upload(){
      if (this.uploadFile === null){
        alert('ファイルが指定されていません。')
        return
      }
      if (this.current == "2") {
        if (!confirm("ユーザーを削除しますか?")) {
          return;
        }
      }
      var blob = new Blob([this.uploadFile], {type: 'application/octet-stream'})
      var fileName = this.uploadFile.name
      var hospitalCode = this.$store.getters.hospital.code
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        const apiPath = this.setApiPath(hospitalCode, fileName);
        axios.post(apiPath, blob,{
              headers: this.headersUploadStream(accessToken) //TODO Test
        }).then(res => {
          if(res.errorMessage) {
            this.message = res.errorMessage
          } else {
            this.reset()
            alert('ファイルをアップロードしました。')
            this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/index'))
          }
        })
      }}).catch((err) => {
        this.message = err.message
      })
    },
    setApiPath(hospitalCode, fileName) {
      if (this.current == "1") return `/api/user/csv/${hospitalCode}/${fileName}`;
      else if (this.current == "2") return `/api/user/csv/delete/${hospitalCode}/${fileName}`;
      else if (this.current == "3") return `/api/user/csv/update/${hospitalCode}/${fileName}`;
      else if (this.current == "4") return `/api/user/csv/conference/${hospitalCode}/${fileName}`;
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/index'))
    },
    reset() {
      var input = this.$refs.file
      input.value = ''
      this.uploadFile = null
    },
    download() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var fileName = this.setFileName();
          axios.post("/api/csv-format/download/", {
              fileName: fileName
            },{
              headers: this.headers(accessToken),
              responseType: "blob"
          }).then(response => {
            const blob = new Blob([response.data], {
              type: response.data.type
            })
            FileSaver.saveAs(blob, fileName)
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    setFileName() {
      if (this.current === "1") return "users.csv";
      else if (this.current === "2") return "deleteUsers.csv";
      else if (this.current === "3") return "updateUsers.csv";
      else if (this.current == "4") return "user-conference-info.csv";
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>